// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OpinionCard_wrapper__IZ_mA","userData":"OpinionCard_userData__Ro_6J","userName":"OpinionCard_userName__xdB0z","userTitle":"OpinionCard_userTitle__i5nF0"};